export default __webpack_public_path__ + "static/media/cc-task-description.602f6ca2.jpg";